import { atom } from "jotai";

const userDataAtom = atom(null);
const billingDataAtom = atom(null);

export const globalStore = {
    userDataAtom,
    billingDataAtom,
};
